import React, { Component } from 'react';
import LoginForm from '../components/login_form';
import AuthService from '../services/user_service';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import './landing_screen.css';

class LoginScreen extends Component {
    state = {
        username: '',
        password: '',
        submitting: false,
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };


    handleLogin = (e) => {
        e.preventDefault();
        if (this.state.submitting) return;
        const { username, password } = this.state;

        this.setState({ submitting: true });
        AuthService.login({
            email: username,
            password: password
        })
        .then(response => {
            if (response.data.success) {
                // Save user details from backend
                localStorage.setItem("user", JSON.stringify(response.data.user));

                // Redirect
                window.location.href = "/";
                toast.success("Login successful!");
            } else {
                toast.error(response.data.message || "Login failed");
            }
        })
        .catch(err => {
            console.error(err);
            toast.error("Invalid email or password");
        })
        .finally(() => this.setState({ submitting: false }));
    };

    render() {
        const { username, password, submitting } = this.state;

        return (
            <main className="portal-login">
                <section className="login-showcase">
                    <Link to="/" className="login-brand">
                        <img src="/bhepl_logo.webp" alt="BHEPL" />
                        <span>Design Automation</span>
                    </Link>
                    <div className="login-showcase-copy">
                        <span>PROJECT WORKSPACE</span>
                        <h1>Good work starts<br />with <em>clarity.</em></h1>
                        <p>Manage station documents, follow verification progress, and generate design deliverables from one connected workspace.</p>
                        <div className="login-showcase-points">
                            <span><i className="bi bi-check2" aria-hidden="true"></i> Station documents</span>
                            <span><i className="bi bi-check2" aria-hidden="true"></i> Revision tracking</span>
                            <span><i className="bi bi-check2" aria-hidden="true"></i> Guided generation</span>
                        </div>
                    </div>
                    <footer className="login-showcase-footer">
                        <span>BHEPL Design Automation</span>
                        <span>Secure project access</span>
                    </footer>
                </section>
                <section className="login-panel">
                    <div className="login-card">
                        <div className="login-card-heading">
                            <span>WELCOME BACK</span>
                            <h2>Sign in to continue</h2>
                            <p>Use your account credentials to access your workspace.</p>
                        </div>
                        <LoginForm
                            username={username}
                            password={password}
                            onChange={this.handleChange}
                            onSubmit={this.handleLogin}
                            isSubmitting={submitting}
                        />
                        <div className="login-security-note">
                            <i className="bi bi-shield-lock" aria-hidden="true"></i>
                            Your workspace is available to authorized team members.
                        </div>
                        <div className="text-center">
                            <Link to="/" className="login-back-link">
                                <i className="bi bi-arrow-left me-1" aria-hidden="true"></i>
                                Back to home
                            </Link>
                        </div>
                    </div>
                </section>
            </main>
        );
    }
}

export default LoginScreen;
